import { StatusBar } from 'expo-status-bar';
import AppProviders from './app/contexts/AppProviders';
import ScreenMain from './app/screens/ScreenMain';

export default function App() {
  return (
    <>
      <StatusBar style="auto" />
      <AppProviders>
        <ScreenMain />
      </AppProviders>
    </>
  );
}